module.exports = __webpack_public_path__ + "img/mianfeibox.662e1da9.png";